import { Link } from 'react-router-dom'
import { Section, Badge } from '@vanilla/ui'
import { ArrowLeft, ArrowRight } from 'lucide-react'

const apps = [
  {
    name: 'VoxNote',
    description: 'Voice notes with AI refinement',
    icon: '🎙️',
    href: '/labs/apps/voxnote',
    badge: 'iOS',
    available: true,
  },
]

const comingSoon = [
  {
    name: 'ArenaMind',
    description: 'AI-powered competitive analysis',
    icon: '🎯',
  },
  {
    name: 'PlaySense',
    description: 'Gaming performance insights',
    icon: '🎮',
  },
]

export function Labs() {
  return (
    <Section className="py-20">
      <div className="mx-auto max-w-3xl">
        <Link
          to="/"
          className="mb-12 inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          KHC One
        </Link>

        <h1 className="mb-2 text-4xl font-bold tracking-tight sm:text-5xl">
          KHC Labs
        </h1>

        <p className="mb-12 text-lg text-muted-foreground">
          Apps, platforms, and AI systems
        </p>

        {/* Apps Section */}
        <div className="mb-12">
          <h2 className="mb-4 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Apps
          </h2>
          <div className="space-y-4">
            {apps.map((app) => (
              <Link
                key={app.name}
                to={app.href}
                className="flex items-center gap-5 rounded-2xl bg-card p-6 transition-all hover:translate-x-1 hover:bg-card/80"
              >
                <div
                  className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-xl text-2xl"
                  style={{
                    background: 'linear-gradient(135deg, #FF6B4A, #FF8A70)',
                  }}
                >
                  {app.icon}
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold">{app.name}</h3>
                  <p className="text-sm text-muted-foreground">{app.description}</p>
                </div>
                <Badge>{app.badge}</Badge>
                <ArrowRight className="h-5 w-5 text-muted-foreground" />
              </Link>
            ))}
          </div>
        </div>

        {/* Coming Soon Section */}
        <div className="mb-12">
          <h2 className="mb-4 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Coming Soon
          </h2>
          <div className="space-y-4">
            {comingSoon.map((app) => (
              <div
                key={app.name}
                className="flex items-center gap-5 rounded-2xl bg-card p-6 opacity-60"
              >
                <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-xl bg-muted text-2xl">
                  {app.icon}
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold">{app.name}</h3>
                  <p className="text-sm text-muted-foreground">{app.description}</p>
                </div>
                <Badge variant="secondary">Soon</Badge>
              </div>
            ))}
          </div>
        </div>

        <p className="text-center text-sm text-muted-foreground">
          © 2025 KHC Labs ·{' '}
          <Link to="/" className="text-primary hover:underline">
            KHC One
          </Link>
        </p>
      </div>
    </Section>
  )
}
